import { CancelOutlined, SaveOutlined } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Button, Typography } from '@mui/material'
import { FunctionComponent } from 'react'

export const DialogSaveButtons: FunctionComponent<{
  cancelHandler?: () => void,
  submitHandler: () => void,
  isSubmitting: boolean | undefined,
  buttonInitialText?: string,
  buttonLoadingText?: string,
  isForm?: boolean,
  disableSaveButton?: boolean,
  hideCancelButton?: boolean,
  disableCancelButton?: boolean,
  // Why the save button is disabled, shown as helper text beside the buttons so a
  // greyed-out Save never reads as broken. Only rendered while the button is disabled.
  disabledReason?: string,
}> = ({
  cancelHandler,
  submitHandler,
  isSubmitting,
  buttonInitialText = 'Save',
  buttonLoadingText = 'Saving',
  isForm = false,
  disableSaveButton = false,
  hideCancelButton = false,
  disableCancelButton = false,
  disabledReason,
}) => {
    return (
      <>
        {disableSaveButton && !isSubmitting && disabledReason &&
          <Typography variant='caption' sx={{ color: 'text.secondary', alignSelf: 'center', textAlign: 'right' }}>
            {disabledReason}
          </Typography>}
        {!hideCancelButton && cancelHandler &&
          <Button variant='text' onClick={cancelHandler} disabled={isSubmitting || disableCancelButton} sx={{ mr: isForm ? 3 : 0 }}>
            <CancelOutlined />
            <Typography sx={{ p: 0.5 }}>Cancel</Typography>
          </Button>}
        <LoadingButton
          onClick={submitHandler}
          loadingPosition="start"
          startIcon={<SaveOutlined />}
          loading={isSubmitting}
          disabled={isSubmitting || disableSaveButton}
          variant='contained' >
          <Typography>{isSubmitting ? buttonLoadingText : buttonInitialText}</Typography>
        </LoadingButton>
      </>
    )
  }